import moment from 'moment';
import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import makeStyles from '@material-ui/styles/makeStyles';
import { pluralizeDays, _T } from 'appI18n';
import { formatMoney } from 'utils.ts';
import AccomodationTab from '../AccomodationTab';
import AccomodationTabs from '../AccomodationTabs';
import AccomodationVariantList from '../AccomodationVariantList';
import TourVariantPrice from '../TourVariantPrice';
const useAccomodationTableStyles = makeStyles({
    hotelscol: { width: "20%" },
    availcol: { width: "15%" },
    accmdcol: { width: "20%" },
    pricecol: { width: "10%" },
    mealcol: { width: "10%" },
    actionscol: { width: "40%" },
});
function formatUtcDDMM(isoDate) {
    const date = new Date(isoDate);
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const dd = day.toString().padStart(2, "0");
    const mm = month.toString().padStart(2, "0");
    return (window.language == 'en') ? `${mm}/${dd}` : `${dd}.${mm}`;
}
function mapToSimpleTourVariants(variants) {
    return variants
        .sort(({ checkInDate: a, duration: ad }, { checkInDate: b, duration: bd }) => a < b ? -1 : a == b ? (ad < bd ? -1 : ad == bd ? 0 : 1) : 1)
        .map(variant => [
        variant,
        variant.priceVariants.sort((a, b) => a.price - b.price)[0]
    ]);
}
function AccommodationSelector(props) {
    const [currentVariantId, setCurrentVariantId] = useState(() => {
        const cheapest = props.item.findCheapestTourVariant();
        return cheapest ? cheapest[0].id : undefined;
    });
    const variants = useMemo(() => mapToSimpleTourVariants(props.item.variants), [props.item]);
    const currentVariant = useMemo(() => variants.find(([{ id }]) => id === currentVariantId), [currentVariantId]);
    const accmdClasses = useAccomodationTableStyles();
    const handleChange = (_event, variantId) => {
        setCurrentVariantId(variantId);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(AccomodationTabs, { value: currentVariantId, onChange: handleChange }, variants.map(([variant, { accomodationVariants, priceItem, price }]) => {
            const title = `${formatUtcDDMM(variant.checkInDate)}, ${variant.duration} ${pluralizeDays(variant.duration)}`;
            const minPrice = price;
            //const minPrice = accomodationVariants.length > 0
            //    ? variant.calcTourPrice(accomodationVariants[0])
            //    : NaN;
            return React.createElement(AccomodationTab, { title: title, subtitle: `${_T.COMMON_FROM} ${formatMoney(minPrice, { currency: props.item.currency.name })} ${props.item.currency.name}`, key: variant.id, value: variant.id });
        })),
        (() => {
            if (!currentVariant)
                return null;
            const [tourVariant, accmdVariants] = currentVariant;
            return (React.createElement(AccomodationVariantList, { classes: accmdClasses }, tourVariant.priceVariants.map((x, i) => (React.createElement(TourVariantPrice, { key: i, tour: props.item, tourVariant: tourVariant, priceItem: x, genUrl: props.genUrl, book: props.book, hash: x.priceItem.servicesHash })))));
        })()));
}
function DateSelector(props) {
    return (React.createElement(Table, null,
        React.createElement(TableBody, null, props.item.variants.map(x => React.createElement(TableRow, { key: x.id },
            React.createElement(TableCell, null,
                moment(x.checkInDate).format('L'),
                ", ",
                x.duration,
                " ",
                pluralizeDays(x.duration)),
            React.createElement(TableCell, { align: "right" },
                React.createElement(Button, { color: "primary", startIcon: React.createElement(ShoppingCartOutlinedIcon, null), onClick: () => props.book(x, undefined, x.priceVariants[0].priceItem.servicesHash) }, _T.COMMON_BUY),
                React.createElement(Link, { to: props.genUrl(x.id, undefined, x.priceVariants[0].priceItem.servicesHash) },
                    React.createElement(Button, { color: "secondary", startIcon: React.createElement(VisibilityOutlinedIcon, null) }, _T.COMMON_VIEW))))))));
}
/**
 * Табы с вариантами даты заезда и списком вариантов проживания для выбранной даты.
 */
function TourVariantSelector(props) {
    return React.createElement("div", null, props.item.variants[0].priceVariants[0].accomodationVariants.length
        ? React.createElement(AccommodationSelector, Object.assign({}, props))
        : React.createElement(DateSelector, Object.assign({}, props)));
}
export default TourVariantSelector;
